import marketingInstance from './instance'

const getIsValidMarketingCoupon = (codeId) => {
  return marketingInstance.get(`/coupons/code/${codeId}`)
}

export default getIsValidMarketingCoupon
